import { render, staticRenderFns } from "./FilesList.vue?vue&type=template&id=22074e9d&scoped=true"
import script from "./FilesList.vue?vue&type=script&lang=js"
export * from "./FilesList.vue?vue&type=script&lang=js"
import style0 from "./FilesList.vue?vue&type=style&index=0&id=22074e9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22074e9d",
  null
  
)

export default component.exports